import { ITickersSort, Network, enums, helpers } from '@kattana-io/common';
import { UPDATE, UPDATE_PARAMS, GET_NEXT_PAGE } from '../actions/modal_search';
import { liquidityDescTickersSort } from '../components/Modal/TickersModal/helpers';
import { networks, testnetNetworks } from '../components/NetworkSelector/core';

export const EXCLUDED_KINDS: SearchKind[] = ['testnet'];

export const searchCexList: SearchSelectList = helpers.exchanges.CEX_LIST.map(
  (item) => ({
    kind: enums.ETickerKind.CEX,
    item,
  })
);
export const searchDexList: SearchSelectList = networks.map((item) => ({
  kind: enums.ETickerKind.DEX,
  item,
}));
export const testnetsList: SearchSelectList = testnetNetworks.map((item) => ({
  kind: enums.ETickerKind.DEX,
  item,
}));

export type SearchSelectList = Array<
  | { kind: typeof enums.ETickerKind.CEX; item: string }
  | { kind: typeof enums.ETickerKind.DEX; item: Network }
>;

export enum ECurrentTab {
  SymbolSearch = 'Symbol Search',
  Watchlist = 'Watchlist',
}
export type SearchKind = enums.ETickerKind | 'testnet';

export interface IModalSearch {
  tickers: any[];
  search: string;
  exchanges: string[];
  chains: string[];
  currentTab: ECurrentTab;
  loading: boolean;
  isNextPageLoading: boolean;
  page: number;
  kind: SearchKind; // 1 - CEX, 2 - DEX, null - All
  sort: ITickersSort;
}

const defaultState: IModalSearch = {
  tickers: [],
  search: '',
  exchanges: [],
  chains: [],
  currentTab: ECurrentTab.SymbolSearch,
  page: 0,
  kind: enums.ETickerKind.ALL,
  loading: true,
  isNextPageLoading: false,
  sort: liquidityDescTickersSort,
};

const tickers_search = (
  state: IModalSearch = defaultState,
  action: any
): IModalSearch => {
  switch (action.type) {
  case UPDATE:
    return {
      ...state,
      // loading: false,
      ...action.payload,
    };
  case GET_NEXT_PAGE:
    return {
      ...state,
      isNextPageLoading: true,
    };
  case UPDATE_PARAMS:
    return {
      ...state,
      ...action.payload,
      loading: true,
    };
  default:
    return state;
  }
};

export default tickers_search;
